// extracted by mini-css-extract-plugin
export default {"placeholder":"history_entry_data_placeholder-module___placeholder___e2f26cfd"};